import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getCardBodyContent } from "@qlik/qlik/src/lib/util/helpers";
import SingleCardNoBorder from "../../Card/Single-Card-No-Border";
import Cta from "@qlik/qlik/src/components/Cta";
import * as styles from "./styles.module.css";

/**
 * CardNoBorder component
 * This component renders a card with no border.
 * @param {Object} data - The data for the card.
 */
const CardNoBorder = ({ data }) => {
    // Destructuring cardItems from data
    const { customId, title, subtitle, cardItems = [], additionalConfiguration, backgroundColor, cta } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    const bodyContent = getCardBodyContent(data, `body ${sectionColorMapping.secondaryTextColor}`);

    // Render the component
    return (
        <section
            id={customId}
            className={`lg:px-25 scroll-mt-20 ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className="container px-0 xl:px-3.75">
                <div className="lg:row">
                    <div className={`px-10 lg:col-12 lg:px-3.25  ${styles.contentWrapper}`}>
                        {title && (
                            <h2 className={`mb-5.5 lg:mb-7.5 ${sectionColorMapping.primaryTextColor}`}>{title}</h2>
                        )}
                        {subtitle && <p className={`body-big ${sectionColorMapping.secondaryTextColor}`}>{subtitle}</p>}
                        {bodyContent && bodyContent}
                    </div>
                </div>
                <div className={`grid gap-x-15.5 lg:gap-y-7 md:grid-cols-2 ${styles.cardsWrapper}`}>
                    {cardItems?.map((cardItem) => (
                        <div className="card" key={cardItem.id}>
                            <SingleCardNoBorder data={cardItem} />
                        </div>
                    ))}
                </div>
                {/* Rendering the CTA if it exists */}
                {cta?.length > 0 && (
                    <div className="mt-2.5 flex flex-col lg:flex-row lg:flex-wrap items-center gap-x-5 lg:mt-7.5 lg:justify-start">
                        {cta?.map((button) => (
                            <Cta key={button.id} data={button} className="mt-5" />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default CardNoBorder;
